import brightscript from "refractor/brightscript";
export default brightscript;